export default "__VITE_ASSET__C4WIncef__"